import { Navigate, Outlet } from "react-router-dom";
import cookiesModifier from "../utils/cookies";

const AuthRoutes = () => {

    const tokenValidationRes = { result: cookiesModifier.getCookie('imm_consultant_token') };

    return (
        !tokenValidationRes.result
            ? <Outlet />
            : <Navigate to="/" replace />
    );
};

export default AuthRoutes;